import { z } from "zod";
import { SavePortalOnboardingStep } from "./generated/model/savePortalOnboardingStep.js";
export const userSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
});
export const OnboardingStep = SavePortalOnboardingStep;
//# sourceMappingURL=types.js.map